import jsPDF from "jspdf";
import "jspdf-autotable";

const generatePDF = (reports) => {
  if (!reports || reports.length === 0) return;

  const doc = new jsPDF("l", "mm", [841, 594]);

  const tableColumn = [
    "Class",
    "Subject",
    "Lesson Name",
    "Created On"
  ];
  const tableRows = reports.map((report) => [
    report.div_name,
    report.subject,
    report.Lessonname,
    report.created_date,
  ]);

  doc.autoTable(tableColumn, tableRows, { startY: 20 });

  const date = Date().split(" ");
  const dateStr = `${date[1]}${date[2]}${date[3]}_${date[4].replace(/:/g, "-")}`;
  doc.text("Lesson Reports", 14, 15);
  doc.save(`lesson_reports_${dateStr}.pdf`);
};

export default generatePDF;
